import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import autocompleteDepartmentRequest from "@/types/requests/autocompleteDepartment"
import getOperationOffice from '@/types/responses/getOperationOffice';
import getDepartmentResponse from '@/types/responses/getDepartment';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import i18n from '@/lang/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentAutoComplete',
  props: {
    modelValue: {},
    operationOffices: {},
    errorMessages: {},
    isUnaffiliated: { type: Boolean },
    initialItemId: {},
    requstParams: {},
    label: { default: i18n.global.t('pages.common.autocomplete.department') },
    selectFirstIfOnlyOne: { type: Boolean, default: false },
    readonly: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;



const emit = __emit;

const items = ref<getDepartmentResponse[]>([]);

onMounted(() => {
  Api()
    .autoCompleteDepartments(props.requstParams)
    .then((data) => {
      items.value = data;
      if (props.isUnaffiliated) addUnaffiliatedColumn()
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

function addUnaffiliatedColumn() {
  items.value.unshift({
    name: "所属なし",
    operationOfficeId: null,
    id: null
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: props.label,
    itemName: "name",
    items: items.value,
    "operation-offices": __props.operationOffices,
    "error-messages": __props.errorMessages,
    initialItemId: props.initialItemId,
    selectFirstIfOnlyOne: props.selectFirstIfOnlyOne,
    readonly: props.readonly,
    disabled: props.disabled
  }, null, 8, ["modelValue", "label", "items", "operation-offices", "error-messages", "initialItemId", "selectFirstIfOnlyOne", "readonly", "disabled"]))
}
}

})